import { graphql } from "gql.tada";

const textUIPartFragment = graphql(
  `fragment TextUIPart on TextUIPart @_unmask {
    __typename
    text
    streamingState: state
    providerMetadata
  }`,
);

const reasoningUIPartFragment = graphql(
  `fragment ReasoningUIPart on ReasoningUIPart @_unmask {
    __typename
    text
    streamingState: state
    providerMetadata
  }`,
);

const toolUIPartFragment = graphql(
  `fragment ToolUIPart on ToolUIPart @_unmask {
    __typename
    toolType
    toolCallId
    toolState: state
    providerExecuted
    input
    output
    errorText
    callProviderMetadata
    resultProviderMetadata
    preliminary
    toolName
    approval {
      id
      approved
      reason
      isAutomatic
      signature
    }
  }`,
);

const sourceUrlUIPartFragment = graphql(
  `fragment SourceUrlUIPart on SourceUrlUIPart @_unmask {
    __typename
    sourceId
    url
    sourceTitle: title
    providerMetadata
  }`,
);

const sourceDocumentUIPartFragment = graphql(
  `fragment SourceDocumentUIPart on SourceDocumentUIPart @_unmask {
    __typename
    sourceId
    mediaType
    documentTitle: title
    filename
    providerMetadata
  }`,
);

const fileUIPartFragment = graphql(
  `fragment FileUIPart on FileUIPart @_unmask {
    __typename
    mediaType
    filename
    url
    providerMetadata
  }`,
);

const dataUIPartFragment = graphql(
  `fragment DataUIPart on DataUIPart @_unmask {
    __typename
    type
    data
    id
  }`,
);

const stepStartUIPartFragment = graphql(
  `fragment StepStartUIPart on StepStartUIPart @_unmask {
    __typename
    _empty
  }`,
);

const uiMessagePartFragment = graphql(
  `fragment UIMessagePart on UIMessagePart @_unmask {
    __typename
    ... on TextUIPart {
      ...TextUIPart
    }
    ... on ReasoningUIPart {
      ...ReasoningUIPart
    }
    ... on ToolUIPart {
      ...ToolUIPart
    }
    ... on SourceUrlUIPart {
      ...SourceUrlUIPart
    }
    ... on SourceDocumentUIPart {
      ...SourceDocumentUIPart
    }
    ... on FileUIPart {
      ...FileUIPart
    }
    ... on DataUIPart {
      ...DataUIPart
    }
    ... on StepStartUIPart {
      ...StepStartUIPart
    }
  }`,
  [
    textUIPartFragment,
    reasoningUIPartFragment,
    toolUIPartFragment,
    sourceUrlUIPartFragment,
    sourceDocumentUIPartFragment,
    fileUIPartFragment,
    dataUIPartFragment,
    stepStartUIPartFragment,
  ],
);

export const uiMessageFragment = graphql(
  `fragment UIMessage on UIMessage @_unmask {
    __typename
    id
    role
    metadata
    parts {
      ...UIMessagePart
    }
  }`,
  [uiMessagePartFragment],
);

export const workspaceAiWorkflowSkillFragment = graphql(
  `fragment WorkspaceAiWorkflowSkill on WorkspaceAiWorkflowSkill @_unmask {
    __typename
    id
    organizationID
    createdByUserID
    approvedByUserID
    title
    source
    visibility
    status
    originalMarkdown
    normalizedMarkdown
    spec {
      useWhen
      avoidWhen
      steps
      allowedToolNames
      outputContract
      failureHandling
    }
    validationErrors
    approvedAt
    archivedAt
    createdAt
    updatedAt
  }`,
);

export const activeWorkspaceAiWorkflowSkillFragment = graphql(
  `fragment ActiveWorkspaceAiWorkflowSkill on WorkspaceAiWorkflowSkill @_unmask {
    __typename
    id
    title
    visibility
    status
    spec {
      useWhen
      avoidWhen
      steps
      allowedToolNames
      outputContract
      failureHandling
    }
  }`,
);

export const workspaceAiWorkflowSkillListItemFragment = graphql(
  `fragment WorkspaceAiWorkflowSkillListItem on WorkspaceAiWorkflowSkill @_unmask {
    __typename
    id
    title
    visibility
    status
    validationErrors
    spec {
      useWhen
      allowedToolNames
    }
  }`,
);

export const agentChatFragment = graphql(
  `fragment AgentChat on AgentChat @_unmask {
    __typename
    id
    organizationID
    createdByUserID
    createdBy {
      id
      name
      picture
    }
    title
    shared
    activeWorkflowSkills {
      ...ActiveWorkspaceAiWorkflowSkill
    }
    messages {
      ...UIMessage
    }
    createdAt
    updatedAt
  }`,
  [uiMessageFragment, activeWorkspaceAiWorkflowSkillFragment],
);

export const agentChatWorkflowSkillsFragment = graphql(
  `fragment AgentChatWorkflowSkills on AgentChat @_unmask {
    __typename
    id
    activeWorkflowSkills {
      ...ActiveWorkspaceAiWorkflowSkill
    }
  }`,
  [activeWorkspaceAiWorkflowSkillFragment],
);

export const deleteAgentChatPayloadFragment = graphql(
  `fragment DeleteAgentChatPayload on DeleteAgentChatPayload @_unmask {
    __typename
    id
  }`,
);
